  // Selecciona todas las imágenes
  const images = document.querySelectorAll(
    '.image-block[class*="__image_H9Ezcn"] img, \
    .image-block[class*="__image_3y9gVD"] img, \
    .image-block[class*="__image_qaaj8W"] img, \
    .image-block[class*="__image_HtDHgb"] img, \
    .image-block[class*="__image_xRitXY"] img'
  );

  images.forEach(img => {
    // Guarda la posición inicial
    const startX = img.offsetLeft;
    const startY = img.offsetTop;

    // Hace draggable
    gsap.registerPlugin(Draggable);
    Draggable.create(img, {
      type: "x,y",
      edgeResistance: 0.65,
      inertia: true, // permite “aventarlo”
      bounds: window, // opcional: limitar dentro de la ventana
      onRelease() {
        // Regresa lentamente a su posición original
        gsap.to(img, { duration: 2.5, x: 0, y: 0, ease: "elastic.out(0.1, 100)" });
      }
    });
  });